import { Injectable, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { EMPTY, from } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';

import { ApiService } from '../services/api.service';
import { TutorialService } from './tutorial.service';

@Injectable({ providedIn: 'root' })
export class QuickTourOnboardingService {
  private readonly auth = inject(AuthService);
  private readonly api = inject(ApiService);
  private readonly tutorial = inject(TutorialService);
  private initialized = false;
  private automaticPromptStarted = false;

  initialize(): void {
    if (this.initialized) return;
    this.initialized = true;
    this.auth.isAuthenticated$.pipe(
      filter(Boolean),
      take(1)
    ).subscribe(() => this.checkForRequiredTour());
  }

  refresh(): void {
    if (!this.initialized || this.automaticPromptStarted) return;
    this.checkForRequiredTour();
  }

  private checkForRequiredTour(): void {
    if (this.automaticPromptStarted) return;
    this.api.getMySubscription().pipe(
      take(1),
      filter(response => response.onboarding?.tutorial_required === true),
      tap(() => this.automaticPromptStarted = true),
      switchMap(() => from(this.tutorial.start('automatic'))),
      switchMap(() => this.tutorial.ended$.pipe(
        filter(event => event.mode === 'automatic'),
        take(1)
      )),
      switchMap(event => this.api.completeQuickTour(event.outcome)),
      catchError(() => EMPTY)
    ).subscribe();
  }
}
